export enum Icons {
  SpineBones = 'spine',
  Mri = 'mri'
}
